export const AiMarkName = 'aiMark';
export const AiAnimationMarkName = 'aiAnimationMark';
export const AiLoaderNodeName = 'aiLoaderNode';
